"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const systems_1 = require("@/services/systems");
const users_1 = require("@/services/users");
const evaluators_1 = require("@/store/ducks/evaluators");
const buildUsers_1 = require("@/useCases/useCaseUtilities/buildUsers");
function updateEvaluatorsInSystemsUseCase(userId, systemIds, operation) {
    const systemId = systemIds[0];
    return async (dispatch) => {
        dispatch((0, evaluators_1.sendEvaluatorToSystem)(systemId));
        try {
            const payload = {
                systemIds,
                operation,
            };
            await (0, users_1.associateUserToSystem)(userId, payload);
            const systems = await (0, systems_1.getSystem)(systemId);
            const updatedEvaluators = (0, buildUsers_1.buildUsers)(systems.users, true);
            dispatch((0, evaluators_1.sendEvaluatorToSystemSuccess)({
                groupId: systemId,
                evaluators: updatedEvaluators,
            }));
            dispatch((0, evaluators_1.openEvaluatorToast)({ status: "success", message: "Evaluator added" }));
        }
        catch (e) {
            dispatch((0, evaluators_1.sendEvaluatorToSystemError)());
            dispatch((0, evaluators_1.openEvaluatorToast)({
                status: "error",
                message: "An error happened",
            }));
        }
    };
}
exports.default = updateEvaluatorsInSystemsUseCase;
